<template>
<div class="blocks" :class="blocks_cls">

  <div 
    v-for="(block,block_i) in blocks" 
    :key="'block'+block_i"
    class="block block-pics"
    :class="block_cls(block)"
  >
  
    <div class="areas">                            
                      
      <div class="area"
        v-if="piece && piece.type && piece.metadata"
        v-for="(piece,piece_i) in block.pieces"
        :key="'block'+block_i+'piece'+piece_i"
        :class="piece_cls(piece)"
        :ref="'piece'+block_i+'-'+piece_i"
      >


        <template v-if="piece.type == 'model' && piece.metadata && piece.metadata.model">
          
          <template v-if="piece.metadata && piece.metadata.media">
            
            <template v-if="piece_media_is_type('image',piece.metadata.media)">
              <div class="picholder" :style="color_overlay_css(piece.metadata.media)">
                <div v-if="bgimg_or_imgtag(block,piece)=='bgimg'" class="pic" :style="piece_bg_css(piece,piece_i,block)"></div>
                <img v-if="bgimg_or_imgtag(block,piece)=='imgtag'" :src="piece_bg_src(piece)">
              </div>
            </template>

            <template v-if="piece_media_is_type('video',piece.metadata.media)">
              <video-embed :type="piece.metadata.media.type" :video_slug="piece.metadata.media.video_slug" :responsiveblockmode="(block.layout===1)" />
            </template>

          </template>

          <div class="overlay1"></div>

          <div class="new-tag" v-if="piece.metadata.model.is_new">New</div>
          <div class="updated-tag" v-if="piece.metadata.model.is_updated">Updated</div>

          <router-link @click.native.prevent="modelClick($event)" event="" class="linker" :to="'/model/' + piece.metadata.model.slug"></router-link>

          <div class="content-c">                

            <div class="add-to-casting-btn" @click="piece_add_to_casting($event,piece)">
              Add to package
            </div>

            <div class="midliner"></div>

            <router-link class="hi-res-btn" :to="'/model/'+piece.metadata.model.slug">
              See portfolio
            </router-link>

          </div>
          
                    
          <div class="sub-title">
            <span class="first_name">{{piece.metadata.model.first_name}}</span>
            <span class="last_name">{{piece.metadata.model.last_name}}</span>
          </div>
          
        </template>
        

        
        
        <template v-if="piece.type == 'media'">
          
          <template v-if="piece.metadata.media">

            <template v-if="piece_media_is_type('image',piece.metadata.media)">
              <div class="picholder" :style="color_overlay_css(piece.metadata.media)">
                <div v-if="bgimg_or_imgtag(block,piece)=='bgimg'" class="pic" :style="piece_bg_css(piece,piece_i,block)"></div>
                <img v-if="bgimg_or_imgtag(block,piece)=='imgtag'" :src="piece_bg_src(piece)">
              </div>
            </template>

            <template v-if="piece_media_is_type('video',piece.metadata.media)">
              <video-embed :type="piece.metadata.media.type" :video_slug="piece.metadata.media.video_slug" :responsiveblockmode="(block.layout===1)" />
            </template>  

          </template>

          <div class="overlay1"></div>

          <div class="content-c">                

            <div class="add-to-casting-btn" @click="piece_add_to_casting($event,piece)">
                Add to package
            </div>

            <div class="midliner"></div>

            <a class="hi-res-btn" v-if="false && piece.metadata.media && piece_media_is_type('image',piece.metadata.media)" :href="mediaUrl(piece.media_id,'original','jpg')" target="_blank">
                Watch high-res
            </a>
            
            <div class="hi-res-btn" v-if="true && piece.metadata.media && piece_media_is_type('image',piece.metadata.media)" @click="openHiResMedia(mediaUrl(piece.media_id,'original','jpg'))">
                Watch high-res
            </div>            
            
            <div class="hi-res-btn" v-if="piece_media_is_type('video',piece.metadata.media)" @click="modal_open({modal:'video_player',media:piece.metadata.media})">
                Watch video
            </div>            

          </div>

          <template v-if="piece.metadata.media">
            <div class="details">
              <div class="client" v-if="piece.metadata.media.client_text"><span>Client</span> {{piece.metadata.media.client_text}}</div>
              <div class="photographer" v-if="piece.metadata.media.photographer_text"><span>Photographer</span> {{piece.metadata.media.photographer_text}}</div>
            </div>
          </template>
          
        </template>



        

        <template v-if="piece_is_newsarticle(piece) || piece_is_artistgallery(piece)">        
          
          <template v-if="piece.metadata.block_media">
            
            <template v-if="piece_media_is_type('image',piece.metadata.block_media)">
              <div class="picholder" :style="color_overlay_css(piece.metadata.block_media)">
                <div v-if="bgimg_or_imgtag(block,piece)=='bgimg'" class="pic" :style="piece_bg_css(piece,piece_i,block)"></div>
                <img v-if="bgimg_or_imgtag(block,piece)=='imgtag'" :src="piece_bg_src(piece)">
              </div>
            </template>

            <template v-if="piece_media_is_type('video',piece.metadata.block_media)">
              <video-embed :type="piece.metadata.block_media.type" :video_slug="piece.metadata.block_media.video_slug" :responsiveblockmode="(block.layout===1)" />
            </template>

          </template>


          <div class="overlay1"></div>

          <div class="new-tag" v-if="piece.metadata.page.is_new">New</div>
          <div class="updated-tag" v-if="piece.metadata.page.is_updated">Updated</div>

          <div class="content-c">    

            <div class="title1">
              {{piece.metadata.page.title}}
            </div>

            <div class="title2">
              {{piece.metadata.page.subtitle}}
            </div>

          </div>

          <router-link @click.native.prevent="modelClick($event)" event="" class="linker" :to="'/' + piece.metadata.page.slug"></router-link>
          
        </template>





        <template v-if="show_admin_block_metamenu">
          <div class="admin-block-meta-btn" @click="set_piece_admin_modal_active_i('b'+block_i+'p'+piece_i,true)">=</div>
          <div class="admin-block-meta-menu" v-if="piece_admin_modal_active_i['b'+block_i+'p'+piece_i]" @mouseleave="set_piece_admin_modal_active_i('b'+block_i+'p'+piece_i,false)">
              
            <div class="m-btn" v-if="metadata && metadata.model && piece.media_id" @click="model_media_set_as_poster_image(piece.media_id)">
              Set as poster image...
            </div>
              
          </div>
        </template>


      </div>	

    </div>
  </div>
  
</div>    
</template>

<script>

import helpers from '.././helpers.js'
import mixins from '.././mixins.js'
//import Rellax from 'Rellax'

import VideoEmbed from '.././components/VideoEmbed.vue'

export default {
  props: [ 'blocks', 'metadata' ],
  mixins: [ mixins.generic ],
  components: { VideoEmbed, },
  data(){ return {

    piece_admin_modal_active_i: {},

    imgs_fetched: [],

    rellax: undefined,

  }},
  computed:{

    show_admin_block_metamenu(){
      return false // this part is currently not in use
      if( !this.loggedin_user ) return false
      if( !this.metadata ) return false
      if( !this.metadata.model ) return false
      return true
    },


    model_list_active_book(){
      if( !this.metadata ) return
      return this.metadata.active_book
    },

    blocks_cls(){
      var rn = ( this.$route && this.$route.current && this.$route.current.name ) ? this.$route.current.name : ''
      var cls = {}

      if( this.route_tags.model_single && this.route.parts[3] && this.route.parts[3] == 'full-book' ) {
        cls['model-fullbook'] = true
      }

      if( this.metadata && this.metadata.page_slug ) cls['page-slug-'+this.metadata.page_slug] = true

      return cls
    },

  },
  methods: {

    unslugify: helpers.unslugify,

//--------------------------------------------------------------------------------

    
    //piece_is_modelmedia( piece ) {},
    
    //piece_is_staticpage( piece ) {},

    //piece_is_newsarticle_amanagement( piece ) {},
    //piece_is_newsarticle_scoopmodels( piece ) {},
    //piece_is_newsarticle_scoopsocial( piece ) {},

    piece_is_newsarticle( piece ) {
      
      if( piece.type != 'page' ) return false
      if( !piece.metadata ) return false
      if( !piece.metadata.page ) return false
      if( !piece.metadata.page.category ) return false
      if( piece.metadata.page.category != 'newsarticle' ) return false
      return true

    },    

    piece_is_artistgallery( piece ) {          
      if( piece.type != 'page' ) return false
      if( !piece.metadata ) return false
      if( !piece.metadata.page ) return false
      if( !piece.metadata.page.category ) return false
      if( piece.metadata.page.category != 'artistgallery' ) return false
      return true
    },

//--------------------------------------------------------------------------------

    bgimg_or_imgtag(block,piece) {
      if( block.layout == '1' ) return 'imgtag'
      if( this.is_site_am ) return 'imgtag'
      return 'bgimg'
    },

    modelClick( e ){

      var _this = this
      var el = e.target
      
      var link = el.getAttribute('href')      
      var area_el = el.closest('.area')
      area_el.classList.add('stay')

      //var otherblocks_els = document.querySelectorAll('.blocks .area:not(.stay)')
      var otherblocks_els = document.querySelectorAll('.blocks .area')
      
      for( var i = 0; i < otherblocks_els.length; i++ )  {
        otherblocks_els[i].classList.add('fading-away-inactive')
      }

      //console.log(area_el)
      //console.log(otherblocks_els)

      //classList.add('vanish')

			setTimeout(function(){
        
        _this.$router.push(link)
        
      }, 450 )

      return
      
      // get by id

      var el = event.target
      el.parentNode.removeChild(el)

      var piece_el = el.closest('.area')
      console.log(piece_el)

      //piece_el.parentNode.removeChild(piece_el)


      //var el2 = this.$refs[ 'piece'+block_i+'-'+piece_i ]
      //console.log(el2)

    },

//--------------------------------------------------------------------------------

    set_piece_admin_modal_active_i(key, boolean ){
      this.$set( this.piece_admin_modal_active_i, key, boolean )
    },

//--------------------------------------------------------------------------------

    block_cls(block){
      var cls = {}
      
      cls['block-pics-'+block.layout] = true


      for( var i = 0; i < block.pieces.length; i++ ) {
        var piece = block.pieces[i]
        if( piece && piece.type == 'model' ) {
          cls['has-model-piece'] = true
        }
      }

      return cls
    },

//--------------------------------------------------------------------------------

    piece_cls(piece){
      var cls = {}
      if( piece.type ) cls['type-'+piece.type] = true

      if( piece.metadata && piece.metadata.media && piece.metadata.media.landscape ) cls['media-landscape'] = true
      if( piece.metadata && piece.metadata.block_media && piece.metadata.block_media.landscape ) cls['media-landscape'] = true


      //var img_src = this.$store.state.base_url + 'uploads/media/'+ piece.media_id +'_900x900.jpg'
      //if( this.img_is_fetched(img_src) ) cls['img-fetched'] = true

      return cls
    },

//--------------------------------------------------------------------------------

    piece_bg_src( piece, size ){
      if( !piece ) return
      
      if( !size ) size = 900
      if( size != 'original' ) size = size + 'x' + size

      var src

      var meta = piece.metadata

      if( piece.media_id ) {
        src = this.$store.state.base_url + 'uploads/media/'+ piece.media_id +'_'+size+'.jpg'
      }
     
      if( piece.type == 'page') {
        if( meta && meta.media ) {
          src = this.$store.state.base_url + 'uploads/media/'+ meta.media.id +'_'+size+'.jpg'
        }

        if( meta && !meta.media && meta.page.block_media_id ) {
          src = this.$store.state.base_url + 'uploads/media/'+ meta.page.block_media_id +'_'+size+'.jpg'
        }
      }

      if( meta ) {
        if( meta.media && meta.media.cachebuster ) src += '?' + meta.media.cachebuster
        if( meta.block_media && meta.block_media.cachebuster ) src += '?' + meta.block_media.cachebuster
      }

      return src
    },

//--------------------------------------------------------------------------------

    piece_bg_css(piece,piece_i,block){

      var size = 900

      if( 
        block.layout === '1-1-1' 
        || 
        ( block.layout === '2-1-1' && ( piece_i === 1 || piece_i === 2 ) ) 
        || 
        ( block.layout === '1-1-2' && ( piece_i === 0 || piece_i === 1 ) ) 
      ) {
        if( window.innerWidth < 1000 ) size = 300
       
      }
      

      var css = {}      
      if( !piece ) return
      var src = this.piece_bg_src(piece, size)
      if( !src ) return
      if( src ) css['background-image'] = 'url(' + src + ')'

      

      return css
    },

//--------------------------------------------------------------------------------

    get_piece_media_type( media ){
      if( !media ) return
      if( media.type == 'image' ) return 'image'
      if( media.type == 'youtube' ) return 'video'
      if( media.type == 'vimeo' ) return 'video'
    },
    
    piece_media_is_type( askingtype, media ){
      var piecetype = this.get_piece_media_type(media)
      if( media.type == askingtype ) return true // ask youtube return true on youtube
      return ( piecetype == askingtype ) // ask video return true on youtube
    },

    color_overlay_css(media){
      if( !media ) return
      var color = media.dominant_color
      if( !color ) color = 'EEE'
      color = '#' + color
      return { 'background-color': color }
    },

//--------------------------------------------------------------------------------

    piece_add_to_casting(event,piece){
            
      var rt = this.route_tags
      var item = {}
      
      if( piece.media_id ) item.media_id = piece.media_id
      
      if( rt.model_single ) item.model_id = this.$store.state.loaded_model.id
      
      if( rt.artist_single ) item.artist_id = this.$store.state.loaded_artist.id

      if( rt.influencer_single ) item.influencer_id = this.$store.state.loaded_influencer.id

      if( piece.media_id ) item.media_id = piece.media_id
      if( piece.model_id ) item.model_id = piece.model_id
      if( piece.artist_id ) item.artist_id = piece.artist_id
      if( piece.influencer_id ) item.influencer_id = piece.influencer_id

      if( piece.metadata ) {
        if( piece.metadata.media ) item.media_id = piece.metadata.media.id
        if( piece.metadata.model ) item.model_id = piece.metadata.model.id
        if( piece.metadata.artist ) item.artist_id = piece.metadata.artist.id
        if( piece.metadata.influencer ) item.influencer_id = piece.metadata.influencer.id
      }
      

      this.casting_item_add(item)

      // visual feedback
      var origtext = event.target.innerHTML
      event.target.innerHTML = '· · ·'

      setTimeout(function(){
        event.target.innerHTML = 'Added'
      }, 250)
      
      setTimeout(function(){
        event.target.innerHTML = origtext
      }, 1000)

      var el = document.querySelector('.package-minimenu')
      if(el) {
        el.classList.add('lookatme')
        setTimeout(()=>{ el.classList.remove('lookatme') },1000)
      }

      var title = this.active_casting.title
      this.toast({ text:'Added to package: '+title, position:'bottom-right' })      

      eventBus.$emit('active_casting_save_to_cloud')
      
    },

//--------------------------------------------------------------------------------

    // used to quickly update model media images in model lists (blocklayouts)
    model_media_set_as_poster_image(media_id){
      //this.$store.commit('this.medialib_open({ ', { modal:'model_book_thumb', model:this.metadata.model, media_id:media_id, })
    },

//--------------------------------------------------------------------------------

    // imgs_fetched: [],

    fetch_img( img_src ){

      if( this.img_is_fetched(img_src) ) return

      var image = new Image()
			var _this =  this
			
			// This is the key part: it is basically vanilla JS
			this.loaded = image.addEventListener('load', function(){
				//console.log('img loaded',img_src)
        //_this.$store.commit('add_img_fetched',img_src)
        _this.imgs_fetched.push(img_src)
        
			}) 
			
			// start the load
			image.src = img_src
    },

    img_is_fetched( img_src ){
      //if( this.$store.state.imgs_fetched.indexOf( img_src ) >= 0 ) return true
      if( this.imgs_fetched.indexOf(img_src) >= 0 ) return true
      return false
    },

    fetch_block_imgs(){
      
      var _this = this

      if( !this.blocks ) return

      this.blocks.forEach(function(block){
        block.pieces.forEach(function(piece){

          if( !piece ) return
          
          if( piece.media_id ) {
            _this.fetch_img( _this.mediaUrl(piece.media_id,900) )
            return
          }          

        })  
      })
     
    },

//--------------------------------------------------------------------------------    

    openHiResMedia( url ){

      if( !this.loggedin_user && !helpers.passgate() ) return false

      window.open(url,'_blank')
    },
    
//--------------------------------------------------------------------------------    

  rellax_init(){
    this.rellax = new Rellax('.blocks .areas', {
      speed: -10,
      center: false,
      wrapper: '#main-content',
      round: true,
      vertical: true,
      horizontal: false
    })    
  },

  rellax_kill(){
    if( this.rellax ) this.rellax.destroy()
  },

//--------------------------------------------------------------------------------    

  },

  watch:{

    blocks(){
      this.fetch_block_imgs()
    },

  },

  mounted(){

    this.fetch_block_imgs()
    //this.rellax_init()

  },

  beforeDestroy(){
    //this.rellax_kill()
  },


}
</script>



// WEBPACK FOOTER //
// src/components/Blocks.vue